import React from 'react';

import { chartColors } from '../../config/colors';

interface LabelProps {
    text: string;
    textAnchor?: string;
    fill?: string;
    stroke?: string;
    hasOutline?: boolean;
    scalingFactor?: number;
    transform?: string;
}

export const Label: React.FC<LabelProps> = ({
    text,
    textAnchor = 'start',
    fill = chartColors.fontPrimary,
    stroke = chartColors.backgroundSecondary,
    hasOutline = false,
    scalingFactor = 1,
    transform = ''
}) => {
    return (
        <>
            {hasOutline && (
                <text
                    fontFamily="'Open Sans', OpenSans, sans-serif"
                    fontWeight="bold"
                    fontSize={14 * scalingFactor}
                    textAnchor={textAnchor}
                    dy="-15"
                    fill="none"
                    stroke={stroke}
                    strokeWidth="0.25rem"
                    transform={transform}
                >
                    {text}
                </text>
            )}
            <text
                fontFamily="'Open Sans', OpenSans, sans-serif"
                fontWeight="bold"
                fontSize={14 * scalingFactor}
                textAnchor={textAnchor}
                dy="-15"
                fill={fill}
                transform={transform}
            >
                {text}
            </text>
        </>
    );
};
